import { useMutation, useQueryClient } from "@tanstack/react-query";
import { ApiError, ApiServiceError } from "libs/api";
import { MutationOptions } from "libs/reactQuery";

import { SyncMarketingTemplatesResponse } from "../../marketing.types";
import { requestSyncMarketingTemplates } from "./syncMarketingTemplates.request";

const useSyncMarketingTemplates = (
  options?: MutationOptions<
    SyncMarketingTemplatesResponse,
    ApiServiceError<ApiError>,
    void
  >
) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: requestSyncMarketingTemplates,
    ...options,
    onSuccess: (data, variables, ctx) => {
      void queryClient.invalidateQueries({
        queryKey: ["marketing", "templates"]
      });
      options?.onSuccess?.(data, variables, ctx);
    }
  });
};

export default useSyncMarketingTemplates;
